import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';
import { ProcedureConfigurationService } from '@modules/order/services/procedure-configuration.service';
import { RxProcedureTypeControlComponent } from '@shared/components/rx-procedure-type-control/rx-procedure-type-control.component';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { map, shareReplay } from 'rxjs/operators';

@Component({
	selector: 'rx-intuitive-scan-surgical-guide',
	templateUrl: './rx-intuitive-scan-surgical-guide.component.html',
	styleUrls: ['./rx-intuitive-scan-surgical-guide.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, TlkCardComponent, RxProcedureTypeControlComponent]
})
export class RxIntuitiveScanSurgicalGuideComponent extends BaseDestroyableComponent {
	readonly procedureTitle$ = this.procedureConfigurationService.procedures$.pipe(
		map(procedures => procedures.find(p => p.Id === (ProcedureEnum.ImplantPlanning as number))?.Name ?? ''),
		shareReplay({ bufferSize: 1, refCount: true })
	);

	constructor(private readonly procedureConfigurationService: ProcedureConfigurationService) {
		super();
	}
}
